export default __webpack_public_path__ + "static/media/woman-img-big.e62616d0.svg";